import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/softwares',
    name: 'Software',
    component: () => import('../views/Software.vue')
  },
  {
    path: '/software/:id',
    name: 'SoftwarePost',
    component: () => import('../views/SoftwarePost.vue')
  },
  {
    path: '/designs',
    name: 'Design',
    component: () => import('../views/Design.vue')
  },
  {
    path: '/design/:id',
    name: 'DesignPost',
    component: () => import('../views/DesignPost.vue')
  },
  {
    path: '/setups',
    name: 'Setup',
    component: () => import('../views/Setup.vue')
  },
  {
    path: '/setup/:id',
    name: 'SetupPost',
    component: () => import('../views/SetupPost.vue')
  },
  {
    path: '/stores',
    name: 'Store',
    component: () => import('../views/Store.vue')
  },
  {
    path: '/store/:id',
    name: 'StorePost',
    component: () => import('../views/StorePost.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/hire-me',
    name: 'HireMe',
    component: () => import('../views/HireMe.vue')
  },
  {
    path: "/:catchAll(.*)",
    component: () => import('../views/NotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
